import { toast } from "react-hot-toast";

import { ApiService, LISCase } from "pwapi";

import { LIS } from "shared/actions/constants";
import { AsyncSagaAction, createAsyncSaga } from "shared/utils/asyncActions";

type GetArgs = Parameters<typeof ApiService.caseWithWorkSlide>[0];
export const getCaseForSpecimen = createAsyncSaga(
  LIS.SPECIMEN.GET_CASE.REQUEST,
  LIS.SPECIMEN.GET_CASE.SUCCESS,
  LIS.SPECIMEN.GET_CASE.ERROR,
  (args: GetArgs) => `lis/specimens/${args.id}/case`,
  (args: GetArgs) => ApiService.caseWithWorkSlide(args)
) as AsyncSagaAction<GetArgs>;

type UpdateArgs = Parameters<typeof ApiService.partialUpdateSpecimen>[0];
export const updateSpecimen = createAsyncSaga(
  LIS.SPECIMEN.UPDATE.REQUEST,
  LIS.SPECIMEN.UPDATE.SUCCESS,
  LIS.SPECIMEN.UPDATE.ERROR,
  ({ id }: UpdateArgs) => `lis/specimens/${id}/update`,
  ApiService.partialUpdateSpecimen
) as AsyncSagaAction<UpdateArgs>;

type ScanSpecimenArgs = Parameters<typeof ApiService.scanSpecimen>[0];
export const scanSpecimen = createAsyncSaga(
  LIS.SPECIMEN.SCAN.REQUEST,
  LIS.SPECIMEN.SCAN.SUCCESS,
  LIS.SPECIMEN.SCAN.ERROR,
  ({ id }) => `lis/specimens/${id}/scan`,
  (args: ScanSpecimenArgs) => {
    const tid = toast.loading("Scanned Specimen");
    return ApiService.scanSpecimen(args)
      .then((response: LISCase) => {
        toast.success("Scanned Specimen", { id: tid });
        return response;
      })
      .catch((error) => {
        toast.error(`Scanned Specimen\n${error.message}`, { id: tid });
      });
  }
) as AsyncSagaAction<ScanSpecimenArgs>;

export const printSpecimen = createAsyncSaga(
  LIS.SPECIMEN.PRINT.REQUEST,
  LIS.SPECIMEN.PRINT.SUCCESS,
  LIS.SPECIMEN.PRINT.ERROR,
  ({ id }) => `lis/specimens/${id}/print`,
  ApiService.printSpecimen
) as AsyncSagaAction<Parameters<typeof ApiService.printSpecimen>[0]>;

export const printPieceCountSpecimen = createAsyncSaga(
  LIS.SPECIMEN.PRINT_PIECE_COUNT.REQUEST,
  LIS.SPECIMEN.PRINT_PIECE_COUNT.SUCCESS,
  LIS.SPECIMEN.PRINT_PIECE_COUNT.ERROR,
  ({ id }) => `lis/specimens/${id}/printPieceCount`,
  ApiService.printPieceCountSpecimen
) as AsyncSagaAction<Parameters<typeof ApiService.printPieceCountSpecimen>[0]>;
